import { render, staticRenderFns } from "./newFileUpdloadIcon.vue?vue&type=template&id=65caa433&scoped=true"
import script from "./newFileUpdloadIcon.vue?vue&type=script&lang=js"
export * from "./newFileUpdloadIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65caa433",
  null
  
)

export default component.exports